/**
**  项目管理---项目详情-项目历史界面
 */
<template>
  <div id="ProjectReport" class="jc-page">
    <div class="jc-table-container jc-scroll-panel">
      <template v-if="all_checkup_subject_item_list.length == 0">
      </template>
      <template v-else>
        <div class="subject-list">
          <el-button type="primary" @click="download">导出</el-button>
          <div id="subjectReport" ref="report" style="padding:20px;">
            <div class="subject-item" v-for="subject in all_checkup_subject_item_list" :key="subject.checkup_subject_id">
              <div>{{ subject.checkup_subject_name }}</div>
              <el-table :id="'table' + subject.checkup_subject_id" :data="subject.rowData" :span-method="rowSpanMethod"
                style="margin-bottom:20px;">
                <el-table-column :prop="property.propertyName" v-for="property in properties" :key="property.propertyName"
                  v-if="showColumn(subject, property)" :label="property.columnName">
                  <template slot-scope="scope">
                    <div v-html="renderColumn(property.propertyName, scope.row)"></div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
import htmlDocx from 'html-docx-js/dist/html-docx';
import saveAs from 'file-saver';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
import { getAllCheckupSubjectItemListByPrjectId,generateWordDecumentsForProjectReports } from '@/apis/projects'
export default {
  name: "ProjectReport",
  data() {
    return {
      checkup_project_id: '',
      all_checkup_subject_item_list: [],
      selectColumns: [],
      properties: [
        { propertyName: "checkup_item_no", columnName: "检查编号" },
        { propertyName: "checkup_category_name", columnName: "类别" },
        { propertyName: "checkup_item_name", columnName: "项目" },
        { propertyName: "checkup_item_evaluation_content", columnName: "评估内容" },
        { propertyName: "checkup_item_basic_score", columnName: "标准分" },
        { propertyName: "checkup_item_score_point", columnName: "评分标准" },
        { propertyName: "checkup_item_standard_require", columnName: "标准化要求" },
        { propertyName: "checkup_item_standard_point", columnName: "企业达标标准" },
        { propertyName: "checkup_item_review_method", columnName: "评审方法" },
        { propertyName: "checkup_item_review_criteria_no_but", columnName: "评审标准-否决项" },
        { propertyName: "checkup_item_review_criteria_deduction", columnName: "评审标准-扣分项" },
        { propertyName: "checkup_item_standard_review_number", columnName: "标准化评审规范号" },
        { propertyName: "checkup_item_standard_review_content", columnName: "标准化评审内容" },
        { propertyName: "checkup_item_inspection_content", columnName: "检查内容/考核要求" },
        { propertyName: "checkup_item_inspection_basis", columnName: "检查依据" },
        { propertyName: "checkup_item_inspection_method", columnName: "检查方法" },
        { propertyName: "checkup_item_case_image", columnName: "案例照片" },
        { propertyName: "checkup_item_complete_time_limit", columnName: "完成时限" },
        { propertyName: "checkup_item_evaluation_key_issues", columnName: "是否重点问题" },
        { propertyName: "checkup_item_evaluation_method", columnName: "评估方式" },
        { propertyName: "checkup_item_inspection_point", columnName: "检查要点/支撑材料" },
        { propertyName: "checkup_item_evaluation_problem_description", columnName: "自评/评审描述" },
        { propertyName: "checkup_item_evaluation_improve_time_limit", columnName: "整改时限" },
        { propertyName: "checkup_item_evaluation_project_type_switch", columnName: "问题分类" },
        { propertyName: "checkup_item_evaluation_inspection_result", columnName: "检查结果" },
        { propertyName: "checkup_evaluation_problem_description", columnName: "问题描述" },
        { propertyName: "checkup_evaluation_improve_suggest", columnName: "整改建议" },
        { propertyName: "checkup_item_real_score", columnName: "实际得分" },
      ]
    };
  },
  mounted() {
    this.selectColumns = this.$store.state.user.selectColumns
    this.checkup_project_id = this.$route.params.id
    getAllCheckupSubjectItemListByPrjectId({
      checkup_project_id: this.checkup_project_id
    }).then(res => {
      if (res.data.status == "1") {
        this.all_checkup_subject_item_list = [...res.data.data.all_checkup_subject_item_list]
        this.structData()
      }
    })
  },
  methods: {
    structData() {
      let subjects = []
      for (let i = 0; i < this.all_checkup_subject_item_list.length; i++) {
        if (!this.selectColumns || this.selectColumns.length == 0) {
          continue
        }
        let item = this.selectColumns.find(x => x.checkup_subject_id ==
          this.all_checkup_subject_item_list[i].checkup_subject_id)
        if (item != null && item.selectColumn.length == 0) {
          continue
        }
        let subject = {
          "checkup_subject_id": this.all_checkup_subject_item_list[i].checkup_subject_id,
          "checkup_subject_name": this.all_checkup_subject_item_list[i].checkup_subject_name,
        }
        let checkup_item_list = this.all_checkup_subject_item_list[i].checkup_item_list
        let rowdatas = []
        for (let j = 0; j < checkup_item_list.length; j++) {
          let beforeData = {
            checkup_item_no: checkup_item_list[j].checkup_item_no,
            checkup_category_name: checkup_item_list[j].checkup_category_name,
            checkup_item_name: checkup_item_list[j].checkup_item_name,
            checkup_item_evaluation_content: checkup_item_list[j].checkup_item_evaluation_content,
            checkup_item_basic_score: checkup_item_list[j].checkup_item_basic_score,
            checkup_item_score_point: checkup_item_list[j].checkup_item_score_point,
            checkup_item_evaluation_method: checkup_item_list[j].checkup_item_evaluation_method,
            checkup_item_inspection_point: checkup_item_list[j].checkup_item_inspection_point,
            checkup_item_standard_require: checkup_item_list[j].checkup_item_standard_require,
            checkup_item_standard_point: checkup_item_list[j].checkup_item_standard_point,
            checkup_item_review_method: checkup_item_list[j].checkup_item_review_method,
            checkup_item_review_criteria_no_but: checkup_item_list[j].checkup_item_review_criteria_no_but,
            checkup_item_review_criteria_deduction: checkup_item_list[j].checkup_item_review_criteria_deduction,
            "checkup_item_evaluation_key_issues": checkup_item_list[j].checkup_item_evaluation_key_issues,
            checkup_item_standard_review_number: checkup_item_list[j].checkup_item_standard_review_number,
            checkup_item_standard_review_content: checkup_item_list[j].checkup_item_standard_review_content,
            checkup_item_inspection_content: checkup_item_list[j].checkup_item_inspection_content,
            checkup_item_inspection_basis: checkup_item_list[j].checkup_item_inspection_basis,
            checkup_item_inspection_method: checkup_item_list[j].checkup_item_inspection_method,
            checkup_item_case_image: checkup_item_list[j].checkup_item_case_image,
            checkup_item_complete_time_limit: checkup_item_list[j].checkup_item_complete_time_limit,
            checkup_item_real_score: checkup_item_list[j].checkup_item_real_score,
          }
          let checkup_item_inspection_point_content_list =
            checkup_item_list[j].checkup_item_inspection_point_content_list
          let rowdata = []
          let rowspan1 = 0
          checkup_item_inspection_point_content_list.forEach(x => {
            rowspan1 += x.expert_evaluation_list.length == 0 ? 1 : x.expert_evaluation_list.length
          })
          if (rowspan1 == 0) {
            rowspan1 = 1
          }
          let flag1 = false
          let flag2 = false
          checkup_item_inspection_point_content_list.forEach(x => {
            if (x.expert_evaluation_list.length == 0) {
              let row = {
                ...beforeData,
                checkup_subject_item_evaluation_origin_id: x.checkup_subject_item_evaluation_origin_id,
                checkup_item_inspection_point: x.checkup_item_inspection_point,
                evaluation_method_type_info: x.evaluation_method_type_info,
                rowspan1: flag1 ? 0 : rowspan1,
                rowspan2: 1
              }
              flag1 = true
              row.selectColumn = item.selectColumn
              rowdatas.push(row)
            } else {
              let flag2 = false
              x.expert_evaluation_list.forEach(y => {
                let row = {
                  ...beforeData,
                  checkup_subject_item_evaluation_origin_id: x.checkup_subject_item_evaluation_origin_id,
                  checkup_item_inspection_point: x.checkup_item_inspection_point,
                  evaluation_method_type_info: x.evaluation_method_type_info,
                  ...y,
                  rowspan1: flag1 ? 0 : rowspan1,
                  rowspan2: flag2 ? 0 : (x.expert_evaluation_list.length == 0 ? 1 : x.expert_evaluation_list.length)
                }
                flag1 = true
                flag2 = true
                row.selectColumn = item.selectColumn
                rowdatas.push(row)
              })
            }

          })
        }
        subject.rowData = rowdatas
        subjects.push(subject)
      }
      this.all_checkup_subject_item_list = subjects
    },
    goBack() {
      this.$router.back()
    },
    ok() {

    },
    showColumn(subject, property) {
      if (this.selectColumns && this.selectColumns.length > 0) {
        let item = this.selectColumns.find(x => x.checkup_subject_id == subject.checkup_subject_id)
        return item.selectColumn.indexOf(property.propertyName) > -1
      } else {
        return false
      }

    },
    rowSpanMethod({ row, column, rowIndex, columnIndex }) {
      let rowspan1Column = [
        "checkup_item_no", "checkup_category_name", "checkup_item_name", "checkup_item_evaluation_content", "checkup_item_basic_score",
        "checkup_item_score_point", "checkup_item_standard_require", "checkup_item_standard_point", "checkup_item_review_method",
        "checkup_item_review_criteria_no_but", "checkup_item_review_criteria_deduction", "checkup_item_standard_review_number", "checkup_item_standard_review_content",
        "checkup_item_inspection_content", "checkup_item_inspection_basis", "checkup_item_inspection_method", "checkup_item_case_image",
        "checkup_item_complete_time_limit", "checkup_item_evaluation_key_issues", "checkup_item_real_score"
      ]
      let rowspan2Column = ["checkup_item_inspection_point", "checkup_item_evaluation_method"]
      let propertyName = column.property
      let colspan = 0
      if (row.selectColumn && row.selectColumn.length > 0) {
        colspan = row.selectColumn.indexOf(propertyName) > -1 ? 1 : 0
      }


      if (rowspan1Column.indexOf(propertyName) > -1) {
        return { rowspan: row.rowspan1, colspan: colspan }
      }
      if (rowspan2Column.indexOf(propertyName) > -1) {
        return { rowspan: row.rowspan2, colspan: colspan }
      }
      return { rowspan: 1, colspan: colspan }
    },
    renderColumn(property, row) {
      switch (property) {
        case "checkup_item_no": {
          return row.checkup_item_no
        }
        case "checkup_category_name": {
          return row.checkup_category_name
        }
        case "checkup_item_name": {
          return row.checkup_item_name
        }
        case "checkup_item_evaluation_content": {
          return row.checkup_item_evaluation_content
        }
        case "checkup_item_basic_score": {
          return row.checkup_item_basic_score
        }
        case "checkup_item_score_point": {
          return row.checkup_item_score_point
        }
        case "checkup_item_standard_require": {
          return row.checkup_item_standard_require
        }

        case "checkup_item_standard_point": {
          return row.checkup_item_standard_point
        }
        case "checkup_item_review_method": {
          return row.checkup_item_review_method
        }
        case "checkup_item_review_criteria_no_but": {
          return row.checkup_item_review_criteria_no_but
        }
        case "checkup_item_review_criteria_deduction": {
          return row.checkup_item_review_criteria_deduction
        }
        case "checkup_item_standard_review_number": {
          return row.checkup_item_standard_review_number
        }
        case "checkup_item_standard_review_content": {
          return row.checkup_item_standard_review_content
        }

        case "checkup_item_inspection_content": {
          return row.checkup_item_inspection_content
        }
        case "checkup_item_inspection_basis": {
          return row.checkup_item_inspection_basis
        }
        case "checkup_item_inspection_method": {
          return row.checkup_item_inspection_method
        }
        case "checkup_item_case_image": {
          return row.checkup_item_case_image
        }
        case "checkup_item_complete_time_limit": {
          return row.checkup_item_complete_time_limit
        }
        case "checkup_item_evaluation_key_issues": {
          return row.checkup_item_evaluation_key_issues == "0" ? "否" : "是"
        }
        case "checkup_item_evaluation_method": {
          return row.evaluation_method_type_info.evaluation_method_type_name
        }
        case "checkup_item_inspection_point": {
          return row.checkup_item_inspection_point
        }
        case "checkup_item_evaluation_problem_description": {
          return row.checkup_item_evaluation_problem_description
        }
        case "checkup_item_evaluation_improve_time_limit": {
          return row.checkup_item_evaluation_improve_time_limit
        }
        case "checkup_item_evaluation_project_type_switch": {
          return row.checkup_item_evaluation_project_type_switch
        }
        case "checkup_item_evaluation_inspection_result": {
          return row.checkup_item_evaluation_inspection_result
        }
        case "checkup_evaluation_problem_description": {
          return row.checkup_evaluation_problem_description
        }
        case "checkup_evaluation_improve_suggest": {
          return row.checkup_evaluation_improve_suggest
        }
        case "checkup_item_real_score": {
          return row.checkup_item_real_score
        }
      }
    },
    exportFunc: function (e) {
      // 从表生成工作簿对象
      let wb = XLSX.utils.book_new()
      let names = []
      for (let i = 0; i < this.all_checkup_subject_item_list.length; i++) {
        let id = 'table' + this.all_checkup_subject_item_list[i].checkup_subject_id
        let name = this.all_checkup_subject_item_list[i].checkup_subject_name
        let temp = name;
        for (let i = 1; ; i++) {
          if (names.indexOf(temp) == -1) {
            names.push(temp)
            name = temp;
            break;
          }
          temp = name + i
        }
        let ws = XLSX.utils.table_to_sheet(document.getElementById(id), {
          raw: true
        })
        XLSX.utils.book_append_sheet(wb, ws, name)

      }
      // 得到二进制字符串作为输出
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'binary'
      });
      FileSaver.saveAs(new Blob([this.s2ab(wbout)], {
        type: 'application/octet-stream'
      }), '检查列表生成报告.xlsx');
    },
    s2ab: function (s) {
      var cuf;
      var i;
      if (typeof ArrayBuffer !== 'undefined') {
        cuf = new ArrayBuffer(s.length);
        var view = new Uint8Array(cuf);
        for (i = 0; i !== s.length; i++) {
          view[i] = s.charCodeAt(i) & 0xFF;
        }
        return cuf;
      } else {
        cuf = new Array(s.length);
        for (i = 0; i !== s.length; ++i) {
          cuf[i] = s.charCodeAt(i) & oxFF;
        }
        return cuf;
      }
    },
    exportDocx() {
      // 克隆报告HTML
      let contentDocument = this.$refs.report;
      this.convertImagesToBase64(contentDocument);
      this.convertChartsToBase64(contentDocument);

      let content = `<!DOCTYPE html><html>
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
            </head>
            <body>
                ${contentDocument.innerHTML}
            </body>
            </html>`;
      console.log(content);
      let converted = htmlDocx.asBlob(content, { orientation: 'landscape' });
      saveAs(converted, `检查列表生成报告.docx`);

      let link = this.createDownloadLink(converted, `检查列表生成报告.docx`);

      this.$refs.downloadArea.innerHTML = "";
      this.$refs.downloadArea.appendChild(link);
    },

    // 转换图片为 base64 (todo: 有可能因跨域报错)
    convertImagesToBase64(contentDocument) {
      // 找到所有的图片
      let imgs = contentDocument.querySelectorAll("img");

      // 图片转换用
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");

      imgs.forEach((img, i) => {
        if (img.src.startsWith("data:image")) return;

        // img表现尺寸
        let realWidth = parseInt(img.style.width);
        let realHeight = parseInt(img.style.height);

        // 清空画布并调整为 img 的大小
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = realWidth;
        canvas.height = realHeight;

        // 画图片到画布
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          realWidth,
          realHeight
        );
        // ctx.drawImage(img, 0, 0);

        // 画布转为 base64
        let dataURL = canvas.toDataURL();
        img.setAttribute("src", dataURL);
      });

      canvas.remove();
    },

    convertChartsToBase64(contentDocument) {
      // 找到所有的图表 （echart）
      let canvases = contentDocument.querySelectorAll("canvas");

      // 遍历图表，转换为 base64 静态图片
      canvases.forEach((canvas, i) => {
        let echart = this.$refs.chart[i];
        let url = echart.getDataURL();
        let img = document.createElement("img");
        img.src = url;
        canvas.parentNode.replaceChild(img, canvas);
      });
    },

    // 生成下载链接
    createDownloadLink(fileObj, fileName) {
      let link = document.createElement("a");
      link.href = URL.createObjectURL(fileObj);
      link.download = fileName || "document.docx";
      link.appendChild(document.createTextNode("如果没有自动下载，点这里"));
      return link;
    },
    download() {
      this.exportFunc()
      /*
  let tables = document.querySelectorAll("thead")
  let maxWidth = 0
  tables.forEach(x=>{
    if(x.clientWidth > maxWidth){
      maxWidth = x.clientWidth
    }
  })
  this.downloadPDF(document.querySelector('#subjectReport'), "检查列表生成报告.pdf")
      */
    },
    downloadPDF(ele, pdfName) {

      let eleW = ele.offsetWidth;// 获得该容器的宽
      let eleH = ele.offsetHeight;// 获得该容器的高


      let eleOffsetTop = ele.offsetTop;  // 获得该容器到文档顶部的距离
      let eleOffsetLeft = ele.offsetLeft; // 获得该容器到文档最左的距离

      var canvas = document.createElement("canvas");
      var abs = 0;

      let win_in = document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
      let win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）

      if (win_out > win_in) {
        // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
        abs = (win_out - win_in) / 2;    // 获得滚动条宽度的一半
        // console.log(a, '新abs');
      }

      canvas.width = eleW * 2;    // 将画布宽&&高放大两倍
      canvas.height = eleH * 2;




      var context = canvas.getContext("2d");

      context.scale(2, 2);

      context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
      // translate的时候，要把这个差值去掉

      // html2canvas(element).then( (canvas)=>{ //报错
      // html2canvas(element[0]).then( (canvas)=>{
      html2canvas(ele, {
        dpi: 300,
        // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
        useCORS: true  //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      }).then((canvas) => {

        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = contentWidth / 592.28 * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = 595.28 / contentWidth * contentHeight;

        var pageData = canvas.toDataURL('image/jpeg', 1.0);



        var pdf = new JsPDF('l', 'pt', 'a4');

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          //在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
          pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
          // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
        } else {    // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }

        //可动态生成
        pdf.save(pdfName);
      })
    },

  }
};
</script>
<style scoped>
#ProjectReport {
  position: relative;
}

.subject-list {
  text-align: left;
}

.subject-list>div:first-child {
  color: #101010;
  font-size: 14px;
  height: 30px;
}

.subject-item>div:first-child {
  color: #101010;
  font-size: 16px;
  height: 30px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Orgin/ProjectManag/Report/Report.vue